/**
 * Route constants for the Listing feature
 */

export const LISTING_ROUTES = {
	/**
	 * Main listing page
	 */
	MAIN: "/listing",

	/**
	 * Filters page (mobile)
	 */
	FILTERS: "/listing/filters",

	/**
	 * Deal detail page (dynamic)
	 * @param dealId - The deal ID
	 * @returns The deal detail route
	 */
	dealDetails: (dealId: string) => `/listing/${dealId}`,
} as const;
